import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export const CopyButton = ({ value, label = "Copiar", testId }) => {
  const [copied, setCopied] = useState(false);
  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(String(value ?? ""));
      setCopied(true);
      toast.success("Copiado al portapapeles");
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error("No se pudo copiar");
    }
  };
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className="h-7 gap-1.5 px-2 text-muted-foreground hover:text-foreground"
      onClick={onCopy}
      data-testid={testId}
      aria-label={label}
    >
      {copied ? <Check className="h-3.5 w-3.5 text-success" /> : <Copy className="h-3.5 w-3.5" />}
      <span className="text-xs">{copied ? "Copiado" : label}</span>
    </Button>
  );
};

export const HashBlock = ({ value, testId }) => (
  <div className="flex items-center justify-between gap-2 rounded-md border border-border bg-muted/40 px-3 py-2">
    <span className="hash-truncate text-xs text-foreground" data-testid={testId}>
      {value || "—"}
    </span>
    {value ? <CopyButton value={value} label="" /> : null}
  </div>
);
